<!--代办处资料管理-->
<template>
  <div class="AgentProfile">
    <app-breadcrumb/>
    <div class="page-container account">
      <el-form :model="viewData" class="formData" label-position="right" label-width="40%">
        <div v-loading="loading" class="filter">
          <!--基本信息-->
          <p style="margin-top: 0;text-align: left;border-bottom: 1px dashed #616161;padding-bottom: 2px;color: rgb(217 141 26);font-size: 18px;">
            {{ $t('Common.basicInfomation') }}</p>
          <!--所属分公司-->
          <el-form-item :label="$t('miAgent.companyCode')+':'">{{ viewData.companyCode }}</el-form-item>
          <!--代办处编号-->
          <el-form-item :label="$t('miAgent.agentNo')+':'">{{ viewData.agentNo }}</el-form-item>
          <!--代办处名称-->
          <el-form-item :label="$t('miAgent.name')+':'">{{ viewData.name }}</el-form-item>
          <!--代办处级别-->
          <el-form-item :label="$t('miAgent.cardType')+':'">{{
              $lt(initDict.mimembercardtype, viewData.levelType)
            }}
          </el-form-item>
          <!--代办处负责人编号-->
          <el-form-item :label="$t('miAgent.recommendNo')+':'">{{ viewData.recommendNo }}</el-form-item>
          <!--证件类型-->
          <el-form-item :label="$t('miAgent.paperType')+':'">{{
              $lt(initDict.miagentpapertype, viewData.paperType)
            }}
          </el-form-item>
          <!--证件号-->
          <el-form-item :label="$t('miAgent.paperNo')+':'">{{ viewData.paperNo }}</el-form-item>
          <!--收货地址-->
          <p style="margin-top: 0;text-align: left;border-bottom: 1px dashed #616161;padding-bottom: 2px;color: rgb(217 141 26);font-size: 18px;">
            {{ $t('register.us.legend.shipping') }}</p>
          <!--所在地区-->
          <el-form-item :label="$t('miAgent.regionCode')">
            <el-col v-show="!isShow" :span="6">
              <el-select
                  v-model="countrymodel"
                  :placeholder="$t('please.select.country.or.region')"
                  clearable
                  size="mini"
                  value-key="regionId"
                  @change="countrychange"
              >
                <el-option
                    v-for="item in addchoicecountry"
                    :key="item.regionId"
                    :label="item.regionName"
                    :value="item"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col v-show="!isShow" :span="6">
              <el-select
                  v-model="provincemodel"
                  :placeholder="$t('please.select.province')"
                  clearable
                  size="mini"
                  value-key="regionId"
                  @change="provincechange"
              >
                <el-option
                    v-for="item in addchoiceprovince"
                    :key="item.regionId"
                    :label="item.regionName"
                    :value="item"
                />
              </el-select>
            </el-col>
            <el-col v-show="!isShow" :span="6">
              <el-select
                  v-model="citymodel"
                  :placeholder="$t('please.select.city')"
                  clearable
                  size="mini"
                  value-key="regionId"
                  @change="citychange"
              >
                <el-option
                    v-for="item in addchoicecity"
                    :key="item.regionId"
                    :label="item.regionName"
                    :value="item"
                />
              </el-select>
            </el-col>

            <el-col v-show="isShow">
              {{ viewData.areaString }}
            </el-col>
          </el-form-item>
          <!--邮政编码-->
          <el-form-item :label="$t('miAgent.storePost')+':'">
            <span v-show="isShow">{{ viewData.storePost }}</span>
            <el-input v-show="!isShow" v-model.trim="editData.storePost" size="mini" style="width: 170px"/>
          </el-form-item>
          <!--传真-->
          <el-form-item :label="$t('miAgent.fax')+':'">
            <span v-show="isShow">{{ viewData.officeTel }}</span>
            <el-input v-show="!isShow" v-model.trim="editData.officeTel" size="mini" style="width: 170px"/>
          </el-form-item>
          <!--移动电话-->
          <el-form-item :label="$t('miAgent.mobile')+':'">
            <span v-show="isShow">{{ viewData.mobile }}</span>
            <el-input v-show="!isShow" v-model.trim="editData.mobile" size="mini" style="width: 170px"/>
          </el-form-item>
          <!--银行账户信息-->
          <p style="margin-top: 0;text-align: left;border-bottom: 1px dashed #616161;padding-bottom: 2px;color: rgb(217 141 26);font-size: 18px;">
            {{ $t('miAgent.title.accountInfo') }}</p>
          <!--开户银行-->
          <el-form-item :label="$t('miAgent.accountBank')+':'">
            <span v-show="!Switch2">{{ viewData.accountBank }}</span>
            <el-select v-show="Switch2" v-model="editData.accountBank">
              <el-option v-for="i in $ll('mm.bank.list')" :key="i.code" :label="$t(i.title)" :value="i.code"/>
            </el-select>
          </el-form-item>
          <!--户名-->
          <el-form-item :label="$t('miAgent.accountName')+':'">{{ viewData.accountName }}</el-form-item>
          <!--帐号-->
          <el-form-item :label="$t('miAgent.accountCode')+':'">
            <span v-show="!Switch2">{{ viewData.accountCode }}</span>
            <el-input v-show="Switch2" v-model.trim="editData.accountCode" size="mini" style="width: 170px"/>
          </el-form-item>
          <el-form-item>
            <!--编辑-->
            <el-button v-show="isShow" type="primary" @click="editEditData">{{ $t('button.edit') }}</el-button>
            <!--保存-->
            <el-button v-show="!isShow" type="success" @click="upEditDate">{{ $t('button.save') }}</el-button>
            <!--取消-->
            <el-button v-show="!isShow" type="danger" @click="cancelEditData">{{
                $t('operation.button.cancel')
              }}
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>

import {getAlRegionsByID, getLevel1AlRegions} from '@/api/member'
import {editLoginUserInfo, getLoginUserInfo} from '@/api/agent'

import {mapGetters} from 'vuex'

export default {
  name: 'AgentProfile',
  directives: {},
  components: {},
  props: [],
  data() {
    return {
      isShow: true,
      Switch: false,
      Switch2: false,
      loading: false,
      bonusSendType: [],
      editData: {},
      viewData: {},
      languages: [
        {code: 'zh_CN', name: 'Chinese 中文'},
        {code: 'de_DE', name: 'Deutsch 德语'},
        {code: 'en_GB', name: 'English 英语'},
        {code: 'fr_FR', name: 'Français 法语'},
        {code: 'in_ID', name: 'Indonesia 印尼语'},
        {code: 'lt_LT', name: 'Lietuvių 立陶宛语'},
        {code: 'pl_PL', name: 'Polski 波兰语'},
        {code: 'tr_TR', name: 'Türkiye 土耳其语'},
        {code: 'cs_CZ', name: 'Čeština 捷克语'},
        {code: 'mn_MN', name: 'Монгол 蒙古语'},
        {code: 'ru_RU', name: 'Русский 俄语'},
        {code: 'th_TH', name: 'ภาษาไทย 泰语'}
      ],
      initDict: {
        mimembercardtype: 'miagent.cardtype',  //代办处级别
        miagentpapertype: 'miagent.papertype', //证件类型
        mimemberstatus: 'mimember.status',  //状态
        mimemberbonusSsendType: 'bd.bonus_send_type',  //奖金发放方式
        yesno: 'yesno',
      },
      fileList: [],
      countrymodel: '', // 新增选择地区model
      provincemodel: '', // 新增选择省存储model
      citymodel: '', // 新增选择市存储model
      areamodel: '', // 新增选择县存储model
      addchoicecountry: [], // 新增选择国家存储
      addchoiceprovince: [], // 新增选择省存储
      addchoicecity: [], // 新增选择市存储
      addchoicearea: [], // 新增选择县存储
    }
  },
  computed: {
    ...mapGetters([
      'userCode',
      'companyCode',
    ]),
    yesno() {
      return this.$ll(this.initDict.yesno)
    },
    mimembercardtype() {
      return this.$ll(this.initDict.mimembercardtype)
    },
    mimemberhonourLevel() {
      return this.$ll(this.initDict.mimemberhonourLevel)
    },
    miagentpapertype() {
      return this.$ll(this.initDict.miagentpapertype)
    },
    mimemberstatus() {
      return this.$ll(this.initDict.mimemberstatus)
    },
    mimemberbonusSsendType() {
      return this.$ll(this.initDict.mimemberbonusSsendType)
    }

  },
  created() {
    // this.bonusSendType = this.$ll('bd.bonus_send_type')
    getLevel1AlRegions().then(res => {
      this.addchoicecountry = res.data
    }).catch(err => {
      console.error(err)
    })
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      getLoginUserInfo({'memberNo': this.userCode}).then(async res => {
        // console.log(res.data)
        this.viewData = res.data
        let countryItem = this.addchoicecountry.filter(_ => {
          return _.regionId === Number(res.data.country)
        })
        this.countrymodel = countryItem[0]
        // console.log(countryItem, 'countryItem')

        await getAlRegionsByID({'regionId': countryItem[0].regionId}).then(res => {
          this.addchoiceprovince = res.data
        })
        let provinceItem = this.addchoiceprovince.filter(_ => {
          return _.regionId === Number(res.data.province)
        })
        this.provincemodel = provinceItem[0]
        // console.log(provinceItem, 'provinceItem')

        await getAlRegionsByID({'regionId': provinceItem[0].regionId}).then(res => {
          this.addchoicecity = res.data
        })
        let cityItem = this.addchoicecity.filter(_ => {
          return _.regionId === Number(res.data.city)
        })
        this.citymodel = cityItem[0]
        // console.log(cityItem, 'cityItem')
        this.viewData.areaString = countryItem[0].regionName + ' ' +
            provinceItem[0].regionName + ' ' +
            cityItem[0].regionName + ' '
        this.loading = false
        this.isShow = true
        this.Switch = false
        this.Switch2 = false
      }).catch(err => {
        console.warn(err)
        this.loading = false
        this.isShow = true
        this.Switch = false
        this.Switch2 = false
      })
    },
    editEditData() {
      this.isShow = false
      this.Switch = true
      this.Switch2 = false
      this.editData = JSON.parse(JSON.stringify(this.viewData))
    },
    cancelEditData() {
      this.getData()
      this.isShow = true
      this.Switch = false
      this.Switch2 = false
    },
    upEditDate() {
      this.loading = true
      editLoginUserInfo({...this.editData}).then(res => {
        if (res.success) {
          this.getData()
          this.isShow = true
          this.Switch = false
          this.Switch2 = false
          this.$notify({
            title: '',
            message: this.$t('sys.message.updateSuccess'),
            type: 'success'
          })
        }
      }).catch(err => {
        console.warn(err)
        this.loading = false
      })
    },
    // 新增按钮 - 国家change事件
    countrychange(val) {
      this.provincemodel = null
      this.citymodel = null
      this.areamodel = null
      this.countrymodel = val.regionName
      this.editData.country = val.regionId
      getAlRegionsByID({'regionId': val.regionId}).then(res => {
        this.addchoiceprovince = res.data
      }).catch(() => {
      })
    },
    // 新增按钮 - 省change事件
    provincechange(val) {
      this.citymodel = null
      this.areamodel = null
      this.provincemodel = val.regionName
      this.editData.province = val.regionId
      getAlRegionsByID({'regionId': val.regionId}).then(res => {
        this.addchoicecity = res.data
      }).catch(() => {
      })
    },
    // 新增按钮 - 市change事件
    citychange(val) {
      this.areamodel = null
      this.citymodel = val.regionName
      this.editData.city = val.regionId
      getAlRegionsByID({'regionId': val.regionId}).then(res => {
        this.addchoicearea = res.data
      }).catch(() => {
      })
    },
  }
}
</script>
<style lang="scss" scoped>

.formData ::v-deep .el-form-item {
  text-align: left;
  margin-bottom: 0;
}

.el-upload__tip {
  width: 60%;
}

.upload-demo {
  display: flex;
}
</style>
